<template>
  <div>
    <guide-use title="邮箱画像-在线API版本"></guide-use>
    <div class="mailbox-product-list">
      <ul class="list-header">
        <li v-for="label in labels" :key="label">{{ label }}</li>
      </ul>
      <div v-for="item in onlineProducts" :key="item.busi" class="list-body">
        <span data-label="授权配额">{{ toThousands(item.reqtotal || 0) }}次</span>
        <span data-label="剩余配额">{{ toThousands(remainingQuota(item)) }}次</span>
        <span data-label="开通时间">{{ item.ctime || '-' }}</span>
        <span data-label="截止时间">{{ item.expire || '-' }}</span>
        <span data-label="状态">{{ productStatus(item.auditflag) }}</span>
      </div>
    </div>
    <mailbox-charts v-if="hasActiveProduct"></mailbox-charts>
  </div>
</template>

<script>
import GuideUse from '../../../components/mark/guideUse'
import MailboxCharts from './MailboxCharts'
import { toThousands } from '../../../util/common'
import { productStatus, remainingQuota } from '../utils'

export default {
  name: 'RiskMailboxOnline',
  components: { GuideUse, MailboxCharts },
  data () {
    return {
      labels: ['授权配额', '剩余配额', '开通时间', '截止时间', '状态']
    }
  },
  computed: {
    onlineProducts () {
      return this.$store.state.product.filter(item => item.busi === 'black_mailbox_online')
    },
    hasActiveProduct () {
      return this.onlineProducts.some(item => item.auditflag === '5')
    }
  },
  methods: { toThousands, productStatus, remainingQuota }
}
</script>

<style lang="scss" scoped>
.mailbox-product-list {
  background: #fff;
  box-shadow: 0 4px 8px rgba(17, 39, 98, 0.04);
  border-radius: 4px;
  overflow-x: auto;

  .list-header,
  .list-body {
    display: grid;
    grid-template-columns: repeat(5, minmax(130px, 1fr));
    min-width: 720px;

    li,
    span {
      color: #1d243c;
      text-align: center;
    }
  }

  .list-header {
    border-bottom: 1px solid #eaedf2;

    li {
      height: 58px;
      font-size: 16px;
      font-weight: 500;
      line-height: 58px;
    }
  }

  .list-body span {
    height: 75px;
    font-size: 14px;
    font-weight: 400;
    line-height: 75px;
  }
}

@media (max-width: 768px) {
  .mailbox-product-list .list-header {
    display: none;
  }

  .mailbox-product-list .list-body {
    grid-template-columns: 1fr;
    min-width: 0;

    span {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: auto;
      min-height: 54px;
      padding: 8px 12px;
      font-size: 12px;
      line-height: 20px;
      text-align: left;
      word-break: break-all;
      box-sizing: border-box;

      &::before {
        content: attr(data-label);
        flex: 0 0 64px;
        margin-right: 8px;
        color: #6f778a;
        font-size: 12px;
      }
    }
  }
}
</style>
